import { userConstants } from '../constantes/userConstants';
import { datosLocalesHelper } from 'react-comun-seps/lib/helpers/datosLocalesHelper';

var userdecoded = datosLocalesHelper();
const initialState = userdecoded ? { loggedIn: true, user: userdecoded } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
    case userConstants.LOGIN_SUCCESS:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.ACUERDOS_SUCCESS:
      return {
        loggedIn: true,
        acuerdos: action.acuerdos
      };
    case userConstants.SISTEMAS_REQUEST:
      return {
        loggedIn: true,
        user: action.user
      }
    case userConstants.SISTEMAS_SUCCESS:
      return {
        loggedIn: true,
        user: action.sistemas.user.tokenSeps,
        sistemas: action.sistemas.sistemas
      };
    case userConstants.RECUPERACLAVE_SUCCESS:
      return {
        validado: true
      };
    case userConstants.SISTEMA_SELECCIONADO:
    case userConstants.MENUPRINCIPAL_REQUEST:
      return {
        loggedIn: true,
        user: action.sistema.tokenSeps,
        sistema: action.sistema.sistemaSeps
      }
    case userConstants.ORGANIZACIONES_REQUEST:
        return {
          loggedIn: true,
          user: action.user
        }
    case userConstants.ORGANIZACIONES_SUCCESS:
      return {
        loggedIn: true,
        user: action.organizaciones.sistema.tokenSeps,
        sistema: action.organizaciones.sistema.sistemaSeps,
        organizaciones: action.organizaciones.organizaciones
      };
    case userConstants.LOGIN_FAILURE:
    case userConstants.SISTEMAS_FAILURE:
    case userConstants.ORGANIZACIONES_GET_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}